import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_q9nVrfuRCbmK: {
	id: 'prd_q9nVr2DEV2fuRCbmK'
	ident: 'prd_q9nVrfuRCbmK'
	sku: 'simple_premium_6m_31_99_6m_139_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: 1
			price_id: 'prc_1xH262DEV2QOzLeCX'
			amount: 139
			amount_usd: 31.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 31.99
			discount: 107.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: null
			price_id: 'prc_OMsMH2DEV2T6DMXLg'
			amount: 139
			amount_usd: 139
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_q9nVrfuRCbmK, SubscriptionProduct>
const prd_q9nVrfuRCbmK = { ident: 'prd_q9nVrfuRCbmK' } as typeof _prd_q9nVrfuRCbmK

export default prd_q9nVrfuRCbmK
